import styles from "./exampleThumbnails.module.css";
import { useDispatch } from "react-redux";
import { Typography } from "@material-ui/core";

export function ExampleThumbnails({ label, items, itemClickHandler, style }) {
  //items must be an array of {src, url} objects
  // itemClickHandler must accept url as the first argument
  const dispatch = useDispatch();
  return (
    <div
      style={{
        ...style,
      }}
    >
      <div>
        <Typography varian="h3">{label}</Typography>
      </div>
      <div
        style={{
          display: "inline-flex",
          justifyContent: "space-around",
          border: "1px solid darkgrey",
          borderRadius: "4px",
          padding: "20px",
          alignItems: "center",
          flex: "1",
          gap: "10px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {items.map((item, index) => (
          <div key={index} className={styles.demoThumbnail}>
            <img
              draggable={false}
              style={{ flex: 1 }}
              alt={`Edit hotspots on demo spin ${index}`}
              key={item.src}
              src={item.src}
              onClick={() => dispatch(itemClickHandler(item.url))}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
